<template>
<router-view />
</template>

<script>
export default {
  name: 'DataDisplayNormal',
  routeInfo: {
    label: '常规因子',
    icon: 'fa fa-users'
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/00Normal/index.vue